var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_vm._v(" "+_vm._s(_vm.label)+" "),_c('v-radio-group',{attrs:{"value":_vm.value},on:{"change":function($event){return _vm.$emit('change', $event)}}},_vm._l((_vm.radios),function(radio){return _c('v-radio',{key:radio.name,attrs:{"disabled":_vm.disabled,"label":radio.name,"value":radio.name,"error-messages":_vm.validationError}})}),1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }